<div class="container">
    <div class="d-flex align-items-center mb-4">
        <h1 class="mb-0 me-3"><i class="far fa-store text-primary"></i> Orders</h1>
    </div>
    <div class="card round-corners heavy-shadow p-3 mb-3">

        <div class="row align-items-end gx-2">
            <div class="col-xxl-4 col-xl-6 mb-3 mb-xxl-0 mobiscroll-select">
                <label class="form-label d-block">Top Level Account</label>
                <input id="filter-account-input1" class="mobi-input form-control form-control-lg" data-dropdown="true" placeholder="Select Top Level Account" mbsc-select [data]="accounts" [(ngModel)]="filter.accountId" name="accountId" [mbscOptions]="accountOptions" />
            </div>
            <div class="col-xxl-4 col-xl-6 mb-3 mb-xxl-0 mobiscroll-select">
                <label class="form-label d-block">Entity</label>
                <input id="filter-account-input2" class="mobi-input form-control form-control-lg" data-dropdown="true" placeholder="Select Entity" mbsc-select [data]="entities" [(ngModel)]="filter.entityId" name="parentId" [mbscOptions]="parentOptions" />
            </div>
            <div class="col-xxl-4 col-xl mb-3 mb-xxl-0">
                <label class="form-label d-block">PO #</label>
                <input type="number" class="form-control form-control-lg" placeholder="PO #" step="1" [(ngModel)]="filter.poNumber" (ngModelChange)="hideTheList()" />
            </div>
        </div>
        <div class="row align-items-end gx-2 mt-2">
            <div class="col-xxl-5 col-xl mb-3 mb-xxl-0 mobiscroll-select">
                <label class="form-label d-block">Vendor</label>
                <input id="filter-account-input3" class="mobi-input form-control form-control-lg" data-dropdown="true" placeholder="Select Vendor" mbsc-select [data]="vendors" [(ngModel)]="filter.vendorId" name="vendorId" [mbscOptions]="vendorOptions" />
            </div>
            <div class="col-xxl-2 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label d-block">Date Range</label>
                <input id="range" class="form-control form-control-lg mobi-input" placeholder="" mbsc-datepicker [mbscOptions]="dateOptions" [moment]="refToMoment" id="vendorContractExp" name="vendorContractExp" [(ngModel)]="filter.dateRange" />
            </div>
            <div class="col-xxl-2 col-xl-6 mb-3 mb-xxl-0">
                <label class="form-label">Status</label>
                <div class="w-100" ngbDropdown>
                    <button class="btn btn-white btn-lg dropdown-toggle w-100" type="button" id="dropdownMenuButton1" ngbDropdownToggle aria-expanded="false">
                        <span>{{filter.status.text}}</span>
                    </button>
                    <ul class="w-100" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                        <ng-container *ngFor="let status of pdxOrderStatusList">
                            <li *ngIf="filter.status.value !== status.value"><a class="dropdown-item" ngbDropdownItem href="javascript:void(0)" (click)="selectStatus(status)">{{status.text}}</a></li>
                        </ng-container>
                    </ul>
                </div>
            </div>
            <div class="col-xl mb-3 mb-xl-0">
                <div class="row gx-2 justify-content-xxl-end justify-content-center search-btns">
                    <div class="col-auto">
                        <button type="button" class="btn btn-secondary btn-round btn-lg text-uppercase text-strong" (click)="showTheList()"><i class="far fa-search"></i> Search</button>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-white btn-round btn-lg text-uppercase text-strong" (click)="resetFilters()"><i class="far fa-times"></i> Clear</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card round-corners heavy-shadow p-3 text-center" *ngIf="showList">
        <div class="d-flex flex-column flex-md-row justify-content-md-between justify-content-center align-items-center mb-3">
            <h4 class="mb-md-0">{{filter.showing(results.recordsFiltered)}}</h4>
            <button type="button" class="btn btn-round btn-white text-strong" *ngIf="false"><i class="far fa-file-export"></i> Export 30 Orders</button>
        </div>
        <div class="card no-shadow rounded border">
            <div class="table-responsive">
                <table class="table table-striped table-hover align-middle m-0">
                    <thead>
                        <tr>
                            <th>
                                <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="PO #" [cb]="loadList"></table-sorting>
                            </th>
                            <th>
                                <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Order Date" [cb]="loadList"></table-sorting>
                            </th>
                            <th>Status</th>
                            <th>
                                <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Account" [cb]="loadList"></table-sorting>
                            </th>
                            <th>Ordered By</th>
                            <th>
                                <table-sorting [(col)]="filter.sortedColumn" [(dir)]="filter.sortedDirection" colName="Vendor" [cb]="loadList"></table-sorting>
                            </th>
                            <th class="text-right">Total</th>
                            <th class="text-right"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="results.data.length == 0">
                            <td colspan="8" class="text-center">No Results</td>
                        </tr>
                        <tr *ngFor="let orderDetail of results.data" [ngClass]="{'table-danger': orderDetail.errorMessage}" class="table-danger">
                            <td>
                                <template #popover>{{orderDetail.errorMessage}}</template>
                                <a href="javascript:void(0);" class="text-danger mr-2" *ngIf="orderDetail.errorMessage" [ngbPopover]="popover">
                                    <i class="fas fa-exclamation-triangle"></i>
                                </a>
                                {{orderDetail.poNumber}}
                            </td>
                            <td>
                                {{orderDetail.orderDateMilliseconds | localDate}}
                                <small class="text-muted d-block">{{orderDetail.orderDateMilliseconds | localPrettyTime}}</small>
                            </td>
                            <td>
                                {{orderDetail.orderStatusDisplay}}
                            </td>
                            <td>
                                <div>{{orderDetail.accountName}}</div>
                                <div>{{orderDetail.entityName}}</div>
                            </td>
                            <td>
                                {{orderDetail.orderedByName}}
                            </td>
                            <td>
                                <div>{{orderDetail.vendorName}}</div>
                                <div>#{{orderDetail.vendorAccountNumber}}</div>
                            </td>
                            <td class="text-right">
                                {{orderDetail.orderTotal | currency}}
                            </td>
                            <td class="text-right">
                                <div ngbDropdown>
                                    <button class="btn btn-lg btn-white btn-shadow action-btn no-caret" type="button" id="dropdownMenuButton1" ngbDropdownToggle aria-expanded="false">
                                        <i class="far fa-ellipsis-v"></i>
                                    </button>
                                    <ul class="dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton1">
                                        <li *ngIf="orderDetail.errorMessage">
                                            <a class="dropdown-item" href="javascript:void(0);" (click)="clearError(orderDetail.orderId)"><i class="far fa-times fa-fw"></i> Clear Error</a>
                                        </li>
                                        <li *ngIf="orderDetail.canRetransmit">
                                            <a class="dropdown-item" href="javascript:void(0);" (click)="retransmit(orderDetail.orderId)"><i class="far fa-arrow-right-arrow-left fa-fw"></i> Retransmit</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="javascript:void(0);" (click)="viewOrder(orderDetail.orderId)"><i class="far fa-external-link-alt fa-fw"></i> View/Edit</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item" href="javascript:void(0);" (click)="downloadPDF(orderDetail.orderId)"><i class="far fa-download fa-fw"></i> Download PO</a>
                                        </li>
                                        <li>
                                            <a class="dropdown-item text-danger" href="javascript:void(0);" (click)="deleteOrder(orderDetail.orderId)"><i class="far fa-trash-alt fa-fw"></i> Delete PO</a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="p-3 d-md-flex align-items-center justify-content-md-between justify-content-center text-center text-md-left">
            <p class="m-md-0 mb-3">{{filter.showing(results.recordsFiltered)}}</p>
            <ngb-pagination [(page)]="filter.page" [pageSize]="filter.pageSize" [collectionSize]="results.recordsFiltered" (pageChange)="loadList(false)" size="lg" [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="true"></ngb-pagination>
        </div>
    </div>
</div>